// extracted by mini-css-extract-plugin
export default {"form":"eventTable_form__ZgnvK"};